<template>
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              
			<div class="block valute-forms" style="max-width: 500px">
				<div class="header">
					<div class="title">Редактирование валютной пары</div>
				</div>
				<div class="content">
					<form>
						        <model-select :value='tradePair.getValute' :options="valutes.map((valute) => { return {value: valute, text:  `${valute.title} - ${valute.key}`}})"
                               v-model="giveValute"
                                placeholder="Give valute">
         						</model-select>
								<model-select :options="valutes.map((valute) => { return {value: valute, text:  `${valute.title} - ${valute.key}`}})"
                                v-model="getValute"
                                placeholder="Get valute">
         						</model-select>
								 <input type="number" min="0" step='any' v-model="comission" placeholder="Комиссия за данную валютную пару"/>
                                <label>Включить фиксированный лимит: <input type="checkbox" style="display: inline-block;" v-model="isFixedLimit" /></label>
                                <div style="display: flex; justify-content: space-between;">
                                  <input v-if="isFixedLimit" type="number" step='any' v-model="fixedComission" placeholder="Комиссия за данную валютную пару"/>  
                                  <p v-if="isFixedLimit">{{calculatedNumber.toFixed(2)}}</p>
                                </div>
                                

                                 <div style='display: flex;'>
                                    <button type='submit' @click='$emit("close")'>Отмена</button>  <button type='submit' @click='$emit("save", {fixedComission, comission, getValute, giveValute, id: tradePair._id, isFixedLimit})' >Изменить</button>  
                                    

                                 </div>
								
					</form>


				</div>
			</div>
            </div>
          </div>
        </div>
      </transition>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
    name: 'editModal',
    props: ['tradePair', 'valutes' ],
    components: {
        ModelSelect
    },
    data: function(){
        var theData = {
            giveValute: {
            value: this.tradePair.giveValute,
            text:  `${this.tradePair.giveValute.title} - ${this.tradePair.giveValute.key}`
        },
        options : this.valutes.map((valute) => { return {value: valute, text:  `${valute.title} - ${valute.key}`}}),
                    getValute: {
            value: this.tradePair.getValute,
            text:  `${this.tradePair.getValute.title} - ${this.tradePair.getValute.key}`
        },
        comission: this.tradePair.transactionComission,
        isFixedLimit: this.tradePair.isFixedLimit,
        fixedComission: this.tradePair.fixedComission
        }
        return theData
    },
    mounted () {
        const option = this.options.findIndex((item) => {
            return item.text === this.giveValute.text
        })
                const secondOption = this.options.findIndex((item) => {
            return item.text === this.getValute.text
        })
        this.giveValute = this.options[option]
        this.getValute = this.options[secondOption]
    },
    computed: {
        calculatedNumber: function(){
            return this.tradePair.giveValute.course / 100 * (100 - this.fixedComission)
        }
    }
    
}
</script>


<style scoped src='./modal.css'>

</style>


// WEBPACK FOOTER //
// src/components/ui/editModal.vue